/* PortalFileCategoriesContext — mirrors admin FileCategoriesContext
   but reads from `/api/portal/file-categories` so the taxonomy is
   consistent across both surfaces without granting portal users
   admin-scoped access. */
import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PortalFileCategoriesContext = createContext({
    categories: [], byKey: {}, loading: true, error: null,
});

export function PortalFileCategoriesProvider({ children }) {
    const [state, setState] = useState({
        categories: [], byKey: {}, loading: true, error: null });
    useEffect(() => {
        let cancelled = false;
        axios.get(`${API}/portal/file-categories`, {
                withCredentials: true,
            })
            .then((r) => {
                if (cancelled) return;
                const items = r.data?.items || [];
                const byKey = {};
                for (const c of items) byKey[c.key] = c;
                setState({ categories: items, byKey,
                             loading: false, error: null });
            })
            .catch((err) => {
                if (cancelled) return;
                setState({ categories: [], byKey: {},
                             loading: false,
                             error: err?.message || "fetch failed" });
            });
        return () => { cancelled = true; };
    }, []);
    return (
        <PortalFileCategoriesContext.Provider value={state}>
            {children}
        </PortalFileCategoriesContext.Provider>
    );
}

export function usePortalFileCategories() {
    return useContext(PortalFileCategoriesContext);
}
